import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { SocialMediaInputs } from "@/components/profile/SocialMediaInputs";
import { AchievementsInput } from "@/components/profile/AchievementsInput";

interface Achievement {
  id: string;
  title: string;
  description?: string;
}

interface SocialAchievementsCardProps {
  youtubeUrl: string | null;
  instagramUrl: string | null;
  discordUrl: string | null;
  twitchUrl: string | null;
  achievements: Achievement[];
  onYoutubeChange: (value: string) => void;
  onInstagramChange: (value: string) => void;
  onDiscordChange: (value: string) => void;
  onTwitchChange: (value: string) => void;
  onAchievementsChange: (achievements: Achievement[]) => void;
}

export const SocialAchievementsCard = ({
  youtubeUrl,
  instagramUrl,
  discordUrl,
  twitchUrl,
  achievements,
  onYoutubeChange,
  onInstagramChange,
  onDiscordChange,
  onTwitchChange,
  onAchievementsChange
}: SocialAchievementsCardProps) => {
  return (
    <Card className="bg-[#1A2233] border-[#2D3748] col-span-1">
      <CardContent className="pt-6 px-6">
        <div className="space-y-6">
          <SocialMediaInputs
            youtubeUrl={youtubeUrl}
            instagramUrl={instagramUrl}
            discordUrl={discordUrl}
            twitchUrl={twitchUrl}
            onYoutubeChange={onYoutubeChange}
            onInstagramChange={onInstagramChange}
            onDiscordChange={onDiscordChange}
            onTwitchChange={onTwitchChange}
          />

          <div className="mt-8">
            <AchievementsInput
              achievements={achievements}
              onAchievementsChange={onAchievementsChange}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
